import React from 'react';
import { IoChevronDown, IoSearch } from 'react-icons/io5';
import './FiltrosIniciativasElbb.scss';

interface FiltrosIniciativasElbbProps {
  categoriaSelecionada: string;
  onCategoriaChange: (categoria: string) => void;
  termoBusca: string;
  onBuscaChange: (termo: string) => void;
  onBuscar: () => void;
  filtroEtapa1?: string;
  onFiltroEtapa1Change?: (filtro: string) => void;
}

export const FiltrosIniciativasElbb: React.FC<FiltrosIniciativasElbbProps> = ({
  categoriaSelecionada,
  onCategoriaChange,
  termoBusca,
  onBuscaChange,
  onBuscar,
  filtroEtapa1,
  onFiltroEtapa1Change
}) => {
  // Para ELBB, podemos ter subcategorias se necessário no futuro
  // Por enquanto, apenas busca textual
  const categorias = [
    { id: '', label: 'Todas as categorias ELBB' },
    // Adicionar subcategorias ELBB aqui se necessário
  ];

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onBuscar();
    }
  };

  return (
    <div className="filtros-iniciativas-elbb" role="search" aria-label="Filtrar iniciativas ELBB">
      <div className="filtros-iniciativas-elbb__container">

        {filtroEtapa1 !== undefined && onFiltroEtapa1Change && (
          <div className="filtros-iniciativas-elbb__dropdown">
            <label htmlFor="filtro-etapa1-elbb" className="sr-only">Filtrar por etapa 1</label>
            <div className="filtros-iniciativas-elbb__select-wrapper">
              <select
                id="filtro-etapa1-elbb"
                className="filtros-iniciativas-elbb__select"
                value={filtroEtapa1}
                onChange={(e) => onFiltroEtapa1Change(e.target.value)}
                aria-label="Filtro de classificação na Etapa 1"
              >
                <option value="todas">Todas</option>
                <option value="classificadas">Classificadas Etapa 1</option>
                <option value="nao-classificadas">Não Classificadas</option>
              </select>
              <IoChevronDown className="filtros-iniciativas-elbb__select-icon" />
            </div>
          </div>
        )}

        <div className="filtros-iniciativas-elbb__busca">
          <div className="filtros-iniciativas-elbb__busca-wrapper">
            <IoSearch className="filtros-iniciativas-elbb__busca-icon" size={20} aria-hidden="true" />
            <label htmlFor="busca-input" className="sr-only">Buscar iniciativas</label>
            <input
              id="busca-input"
              type="text"
              className="filtros-iniciativas-elbb__busca-input"
              placeholder="O que você procura?"
              value={termoBusca}
              onChange={(e) => onBuscaChange(e.target.value)}
              onKeyPress={handleKeyPress}
              aria-label="Buscar iniciativas"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
